import { render, staticRenderFns } from "./suporte-motivo-cancelamento.vue?vue&type=template&id=3ae87ad5"
import script from "./suporte-motivo-cancelamento.vue?vue&type=script&lang=ts"
export * from "./suporte-motivo-cancelamento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports